import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const SettingsRoutes = defineRoute({
    finance: {
        route: {
            path: "/settings/finance",
            component: () => loadView(import("./SettingsFinance.vue")),
        },
    },
    profile: {
        route: {
            path: "/settings/profile",
            component: () => loadView(import("./SettingsProfile.vue")),
        },
    },
    whatsApp: {
        route: {
            path: "/settings/whatsapp",
            component: () => loadView(import("./SettingsWhatsApp.vue")),
        },
    },
    firebase: {
        route: {
            path: "/settings/firebase",
            component: () => loadView(import("./SettingsFirebase.vue")),
        },
    },
    xendit: {
        route: {
            path: "/settings/xendit",
            component: () => loadView(import("./SettingsXendit.vue")),
        },
    },
});
